<style scoped lang="sass">
.extra-link
  text-align: center
  padding: 1rem 0.5rem
</style>
<template>
  <div>
    <form @submit.prevent="attemptRegistration">
      <!-- fake fields are a workaround for chrome autofill getting the wrong fields -->
      <input style="display:none" type="text" name="usernamefakeout"/>
      <input style="display:none" type="password" name="passwordfakeout"/>
      <div v-if="errors.length">
        <div v-for="error in errors">{{error}}</div>
      </div>
      <div class="input-group">
        <label>FIRST NAME</label>
        <input type="text" placeholder="First Name" v-model="registration.first_name" class="input-control">
      </div>
      <div class="input-group">
        <label>LAST NAME</label>
        <input type="text" placeholder="Last Name" v-model="registration.last_name" class="input-control">
      </div>
      <div class="input-group">
        <label>EMAIL</label>
        <input type="email" placeholder="Email" v-model="registration.email" class="input-control">
      </div>
      <div class="input-group">
        <label>PASSWORD</label>
        <input type="password" placeholder="Password" v-model="registration.password_1" class="input-control">
      </div>
      <div>
        <input type="submit" value="Get Started" class="button positive">
      </div>
    </form>
    <div class="extra-link">
      <router-link :to="{name: 'confirmUser'}">Confirming your email?</router-link>
    </div>
  </div>
</template>
<script>
import api from '../../api';

export default {
  name: 'Register',
  data() {
    return {
      errors: [],
      registration: {
        email: '',
        password_1: ''
      }
    };
  },
  methods: {
    attemptRegistration: function() {
      api.Registration.create({params: {registration: this.registration}})
        .then(() => {
          this.$router.push({name: 'confirmUser', params: {email: this.registration.email}});
        }).catch(({response: {data: {errors}}}) => {
          this.errors = errors;
        })
    }
  }
};
</script>
